import api from "@/lib/api";

export interface PostPauseContractReserveRequest {
  pauseTerm: number;
  contractNumber: string;
}

export interface PostPauseContractReserveResponse {
  status: string;
}

export interface PostPauseContractCancelRequest {
  contractNumber: string;
}

export interface PostPauseContractCancelResponse {
  status: string;
}

export interface PostPauseContractResumeRequest {
  contractNumber: string;
}

export interface PostPauseContractResumeResponse {
  status: string;
  isPaid: boolean;
}

export type ErrorResponse = {
  status: string;
  messageType: string;
  errorCode: string;
};

export default {
  // 一時停止の予約申し込み
  postPauseContractReserve(data: PostPauseContractReserveRequest) {
    return api<
      PostPauseContractReserveRequest,
      PostPauseContractReserveResponse | ErrorResponse
    >({
      endpoint: "contracts/pause/web-api/reserve",
      method: "POST",
      body: data
    });
  },
  // 一時停止の予約取り消し
  postPauseContractCancel(data: PostPauseContractCancelRequest) {
    return api<
      PostPauseContractCancelRequest,
      PostPauseContractCancelResponse | ErrorResponse
    >({
      endpoint: "contracts/pause/web-api/cancel",
      method: "POST",
      body: data
    });
  },
  // 一時停止の即時再開
  postPauseContractResume(data: PostPauseContractResumeRequest) {
    return api<
      PostPauseContractResumeRequest,
      PostPauseContractResumeResponse | ErrorResponse
    >({
      endpoint: "contracts/pause/web-api/resume",
      method: "POST",
      body: data
    });
  }
};
